import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { EASE_OUT } from '../../utils/motion';
import { palacioFieldPolaroids } from '../../data/palacioImages';

/** Field-trip snapshots as tilted instant prints, pinned with a strip of coral tape. */
export function FieldPolaroids() {
  const reduce = useReducedMotion();
  return <section aria-label="From the store visits" className="mt-20 md:mt-28" data-id="element-573" data-mp="u1at5rjycq9u">
      <ul className="flex flex-wrap items-start justify-center gap-10 sm:gap-14" data-id="element-574" data-mp="gaxkto35f9jz">
        {palacioFieldPolaroids.map((photo, i) => <motion.li key={photo.src} className="relative w-[260px] rounded-md bg-white px-3 pb-4 pt-3 shadow-[0_22px_40px_rgba(27,34,32,0.18),0_2px_6px_rgba(27,34,32,0.08)] sm:w-[300px]" style={{
        rotate: photo.tilt,
        marginTop: i % 2 ? 28 : 0
      }} initial={reduce ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} whileHover={reduce ? undefined : {
        rotate: 0,
        y: -4
      }} viewport={{
        once: true,
        margin: '0px 0px 12% 0px'
      }} transition={{
        duration: 0.28,
        ease: EASE_OUT,
        delay: i * 0.06
      }} data-id="element-575" data-mp="l48tluriu0ej" data-mpi={i}>
            <span aria-hidden className="absolute -top-2 left-1/2 h-5 w-12 -translate-x-1/2 -rotate-6 rounded-sm border border-coral/35 bg-[#F9E4DE]/90 shadow-[0_3px_6px_rgba(27,34,32,0.15)]" data-id="element-576" data-mp="2o0odswggyuiq" />
            <div className="aspect-square overflow-hidden rounded-sm bg-[#111]" data-id="element-577" data-mp="1vdan3g3d6v72">
              <img src={photo.src} alt={photo.alt} loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-578" data-mp="1qdxq42is47qr" />
            </div>
            <p className="mt-3 -rotate-1 text-center text-lg leading-tight text-[#1E4B48]" style={{
          fontFamily: "'Caveat', 'Bradley Hand', cursive"
        }} data-id="element-579" data-mp="253ddr9n0jx28">
              {photo.caption}
            </p>
          </motion.li>)}
      </ul>
    </section>;
}